module Meevo.Plugins.ClientIntakeForm {
    import BuilderEnum = Meevo.Plugins.DocsAndForms.BuilderEnum;
    import FormBuilderModel = Meevo.Plugins.DocsAndForms.FormBuilderModel;
    import FormBuilderSection = Meevo.Plugins.DocsAndForms.FormBuilderSection;
    import IDataService = Meevo.Components.BaseClasses.IDataService;

    export class ClientIntakeFormMainSection extends FormBuilderSection {
        private _latestBizType: string;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            busyService: Meevo.Components.Busy.IBusyService,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            $translate: ng.translate.ITranslateService,
            $scope: ng.IScope,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected clientIntakeFormService: ClientIntakeFormService,
            protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService,
            _dataService: IDataService,
            _systemTagsService: Meevo.Plugins.DocsAndForms.SystemTagsFactory
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                _dataService,
                identityService,
                noun,
                busyService,
                modalService,
                sectionSecurityKey,
                trackingService,
                $translate,
                $scope
            );

            this.selectedBuilder = BuilderEnum.None;
            this.formBuilderModel = new FormBuilderModel();
            this.disableCrud = true;

            this.$scope.$on(Meevo.Components.Common.Messages.CLOSE_INTAKE_FORM_DESIGNER, () => {
                this.$scope.$apply(() => {
                    this.closeBuilder();
                });
            });
        }

        public createSectionModelInstance(postAdd: (data: any) => any): void {
            this.takeBackup();
        }

        public rollbackChanges() {
            super.rollbackChanges();
            this.formBuilderModel = new FormBuilderModel();
        }

        public getData(bizType: string): ng.IPromise<void> {
            this._latestBizType = bizType;
            return this.clientIntakeFormService.getForm(bizType, this.$scope)
                .then((form) => {
                    this.model = form;
                    this.formBuilderModel = new FormBuilderModel();
                    this.takeBackup();

                    this.clientIntakeFormService.getUdfControls()
                        .then((res) => {
                            this.formBuilderModel.assignedUDFs = this.docsAndFormsService.populateAssignedUdfs(res, this._model);
                        });
                });
        }

        closeBuilder() {
            this.selectedBuilder = BuilderEnum.None;

            this.getData(this._latestBizType);
        }

        public canSaveLogic(): boolean {
            return true;
        }
    }
}

